import React from 'react'
let PropTypes = React.PropTypes

//Componentes
import * as css from './PanelAuditoria.css'
import classNames from 'classnames/bind'
import api from '../../apiClient/v1'
// Formato del Panel Vencimiento: auditor en mayúsculas y rut QF con 'K' final
import { normalizarCampoPanelVenc, normalizarNombreAuditor, normalizarRutQf } from './panelVencimiento'
let cx = classNames.bind(css)

export class PanelAuditoria extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            error: [],
            enviando: false,
            fotoCambio: '',
            cambiada: false
        }
        this.onInputChange = (key, evt) => {
            let actualizado = {}
            // En el Panel Vencimiento el auditor y el rut QF se guardan ya normalizados
            // (ver panelVencimiento.js). En el Panel IRD se conserva el valor tal cual.
            actualizado[key] = this.props.esVencimiento ? normalizarCampoPanelVenc(key, evt.target.value) : evt.target.value
            this.props.onInputChange(actualizado)
        }
        this.guardarRevision = () => {
            this.setState({ enviando: true })
            this.context.actualizaDatosAuditoria()
                .then(() => {
                    this.setState({
                        enviando: false
                    })
                })
                .catch(err => {
                    console.log(err)
                    this.setState({ enviando: false })
                })
        }
        this.onChangeImage = (e) => {
            this.setState({
                fotoCambio: e.target.files[0],
            }, () => this.cambiarImagen(this.props.datosAuditoria.idAuditoria, this.state.fotoCambio))
        }
        this.cambiarImagen = (idAuditoria, file) => {
            let data = new FormData()
            data.append('imagen', file)
            api.capturasAuditoria(idAuditoria).cambiarImagen(data)
                .then(response => {
                    console.log(response)
                    this.setState({
                        cambiada: true
                    })
                })
                .catch((error) => {
                    console.log(error)
                })
        }
        this.handleRecharge = () => {
            window.location.reload();
        }
    }
    render() {
        const uniqueTime = new Date().getTime();
        // El Panel Vencimiento muestra el nombre del auditor siempre en mayúsculas y
        // el rut QF con el dígito verificador 'k' en mayúsculas (ver panelVencimiento.js)
        const esVencimiento = !!this.props.esVencimiento
        const auditor = this.props.datosAuditoria.auditor
        const rutQf = this.props.datosAuditoria.rut_qf
        
        return (
            <div className="col-md-12">
                <div className="panel panel-default">
                    <h4>{this.props.title}</h4>
                    <div className="panel-body form-horizontal">
                        {/* Fila 1: fecha de captura, rut y nombre del auditor.
                            El label corto (Rut:) usa col-sm-1 y el input del nombre (Auditor)
                            col-sm-3 para que el nombre se vea completo; camposPanel reduce el
                            espacio entre label e input, lo que da mas ancho a los inputs. */}
                        <div className={cx('col-md-12 form-group', 'form__control-label', 'labelPanel', 'camposPanel')}>
                            <label className="col-sm-2 control-label">Fecha Captura:</label>
                            <div className="col-sm-2">
                                {/* value siempre string: evita el warning de React "changing an
                                    uncontrolled input to be controlled" cuando la auditoria aun no
                                    carga (datosAuditoria vacio => fecha_captura undefined). */}
                                <input type="date" className="form-control" placeholder="Fecha Captura" disabled={this.state.enviando || this.props.fcv}
                                    value={this.props.datosAuditoria.fecha_captura || ''} onChange={this.onInputChange.bind(this, 'fecha_captura')}
                                />
                                {this.state.error.fecha_captura && <span className={cx('form__error-message')}>{this.state.error.fecha_captura[0]}</span>}
                            </div>
                            <label className="col-sm-1 control-label">Rut Aud:</label>
                            <div className="col-sm-2">
                                <input type="text" className="form-control" placeholder="Rut Auditor" disabled={this.state.enviando || this.props.fcv}
                                    value={this.props.datosAuditoria.rut_auditor || ''} onChange={this.onInputChange.bind(this, 'rut_auditor')}
                                />
                                {this.state.error.rut_auditor && <span className={cx('form__error-message')}>{this.state.error.rut_auditor[0]}</span>}
                            </div>
                            <label className="col-sm-2 control-label">Auditor:</label>
                            <div className="col-sm-3">
                                <input type="text" className="form-control" placeholder="Auditor" disabled={this.state.enviando || this.props.fcv}
                                    value={(esVencimiento ? normalizarNombreAuditor(auditor) : auditor) || ''} onChange={this.onInputChange.bind(this, 'auditor')}
                                />
                                {this.state.error.auditor && <span className={cx('form__error-message')}>{this.state.error.auditor[0]}</span>}
                            </div>
                        </div>
                        {/* Fila 2: datos del QF. Mismo reparto de columnas que la fila 1
                            para que todo quede calzado verticalmente: 'Local Ceco:' col-sm-2
                            (igual que 'Fecha Captura:') y el numero del local en el col-sm-2
                            siguiente (igual que el input de Fecha Captura); luego 'Rut QF:'
                            col-sm-1 + input col-sm-2 y 'QF:' col-sm-2 + input col-sm-3.
                            Total: 4 + 3 + 5 = 12 columnas. */}
                        <div className={cx('col-md-12 form-group', 'form__control-label', 'labelPanel', 'camposPanel')}>
                            {/* 'Local Ceco:' es un label identico a 'Fecha Captura:' (col-sm-2
                                control-label alineado a la derecha), por lo que ambos labels
                                quedan alineados; el numero del local va en la columna siguiente
                                (la misma columna del input de 'Fecha Captura') y se ve mas grande
                                con .localCeco (ver PanelAuditoria.css). */}
                            <label className="col-sm-2 control-label">Ceco:</label>
                            <div className="col-sm-2">
                                <span className={css.localCeco}>{this.props.esVencimiento ? this.props.auditoria.local_ceco : this.props.datosAuditoria.local_ceco}</span>
                            </div>
                            <label className="col-sm-1 control-label">Rut QF:</label>
                            <div className="col-sm-2">
                                <input type="text" className="form-control" placeholder="Rut QF" disabled={this.state.enviando || this.props.fcv} 
                                // onBlur={this.guardarRevision}
                                    value={(esVencimiento ? normalizarRutQf(rutQf) : rutQf) || ''} onChange={this.onInputChange.bind(this, 'rut_qf')}
                                />
                                {this.state.error.rut_qf && <span className={cx('form__error-message')}>{this.state.error.rut_qf[0]}</span>}
                            </div>
                            <label className="col-sm-2 control-label">QF:</label>
                            <div className="col-sm-3">
                                <input type="text" className="form-control" placeholder="QF" disabled={this.state.enviando || this.props.fcv}
                                    value={this.props.datosAuditoria.qf || ''} onChange={this.onInputChange.bind(this, 'qf')}
                                />
                                {this.state.error.qf && <span className={cx('form__error-message')}>{this.state.error.qf[0]}</span>}
                            </div>
                        </div>
                        {/* Fila 3: indicadores centrados (Android y acta) y boton Guardar al
                            borde derecho, todo en la misma linea. */}
                        <div className={cx('col-md-12 form-group', 'form__control-label', 'labelPanel', 'accionesCentradas')}>
                            {/* Espacio izquierdo: balancea el ancho del lado del boton para que
                                los indicadores queden centrados en el panel. */}
                            <div className={cx('accionLado')}></div>
                            {/* Indicadores centrados */}
                            <div className={cx('accionGrupo')}>
                                {/* Indicador Android: verde si la captura se hizo con celular */}
                                <div className={cx('accionCentrada')}>
                                    <label className="control-label">ANDROID</label>
                                    <span className={this.props.usuario_android ? "glyphicon glyphicon-phone " + css.android_pda : "glyphicon glyphicon-phone " + css.noandroid_pda}></span>
                                </div>
                                {/* Foto del acta: se muestra al pasar el mouse por el icono */}
                                <div className={cx('accionCentrada')}>
                                    <label className="control-label">Acta:</label>
                                    <p className={css.tooltipInicio}>
                                        <span className={"glyphicon glyphicon-eye-open " + css.linkEjecutado}></span>
                                        {/* Solo se pide la imagen cuando existe la ruta del acta; si
                                            foto_acta es undefined/'' el <img> generaba la peticion
                                            /auditoria/{idAuditoria}/undefined?v=... */}
                                        <span className={css.tooltiptextInicio}>
                                            {this.props.foto_acta
                                                ? <img src={`${this.props.foto_acta}?v=${uniqueTime}`} className={css.imagenStock} />
                                                : null}
                                        </span>
                                    </p>
                                </div>
                            </div>
                            {/* Guardar: al borde derecho de esta misma fila */}
                            <div className={cx('accionLado', 'accionLadoDerecho')}>
                                {!this.props.fcv ? <button className={cx("btn btn-md btn-primary", 'btnGuardar')} onClick={this.guardarRevision} disabled={this.state.enviando}><span className="glyphicon glyphicon-floppy-disk" aria-hidden="true" /> Guardar</button> : null}
                            </div>
                        </div>
                        {this.props.canChange ? <div className={cx('col-md-12 form-group', 'form__control-label', 'labelPanel', 'div-option-file', 'camposPanel')}>
                            {/* Fila: cambio de la imagen del acta */}
                            <label className="col-sm-2 control-label">Imagen:</label>
                            <div className="col-sm-2">
                                <button className={cx('btn btn-success', 'btn-file')} title='Cambiar Imagen'>
                                    <span className={"glyphicon glyphicon-picture"}></span><input type="file" accept='image/*' onChange={this.onChangeImage} />
                                </button>
                            </div>
                            {/*this.state.cambiada ? <div className='col-sm-1'>
                                <button className={cx('btn btn-success')} onClick={() => this.handleRecharge}>
                                    <span className={"glyphicon glyphicon-refresh"}></span>
                                </button>
        </div> : null*/}
                        </div> : null}
                    </div>
                </div>
            </div>
        )
    }
}
PanelAuditoria.contextTypes = {
    actualizaDatosAuditoria: PropTypes.func
}


// WEBPACK FOOTER //
// ./frontEnd/auditorias/revision/PanelAuditoria.jsx